import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { ContentBox, TextInput, FormButtons, FormError, PortalForm } from '@portal/kit/pkg/components'

const EditEmail = ({ handleSubmit, submitError, t }) =>
  <ContentBox title={t('account.edit_my_email')}>
    <PortalForm onSubmit={handleSubmit}>
      {
        submitError && <FormError message={submitError} />
      }
      <TextInput name="email" label={t('account.email')} />
      <TextInput name="email_confirmation" label={t('account.email_confirmation')} />
      <FormButtons cancel="/my-account" submit />
    </PortalForm>
  </ContentBox>

EditEmail.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.string,
}

export default withTranslation()(EditEmail)
